import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteFinancingCompany = createAsyncThunk(
  'listFinancingCompanies/fetchDeleteFinancingCompany',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteFinancingCompany(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteFinancingCompanySlice = createSlice({
  name: 'financingCompanies/delete',
  initialState,
  reducers: {
    resetDeleteFinancingCompany: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteFinancingCompany.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteFinancingCompany.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteFinancingCompany.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteFinancingCompanySlice.reducer
export const { resetDeleteFinancingCompany } = deleteFinancingCompanySlice.actions
